<template>
  <div class="serch_border">
    <div class="serchform">
      担保方式：
      <a-tag @click="postSerchData('guarantee')" class="tag-active">不限</a-tag>
      <a-tag :class="{'tag-active':item.dictValue==guarantees}" @click="postSerchData({'guarantee':item.dictValue})" v-for="(item,key) in options.guarantee" :key="key">{{item.dictLabel}}</a-tag>
    </div>
  </div>
  <div class="serch_border">
    <div class="serchform">
      贷款期限：
      <a-tag @click="postSerchData('loanDeadline')" class="tag-active">不限</a-tag>
      <a-tag :class="{'tag-active':item.dictValue==loanDeadlines}"  @click="postSerchData({'loanDeadline':item.dictValue})" v-for="(item,key) in options.loanDeadline" :key="key">{{item.dictLabel}}</a-tag>
    </div>
  </div>
  <div class="serch_border">
    <div class="serchform">
      还款方式：
      <a-tag @click="postSerchData('paymentType')" class="tag-active">不限</a-tag>
      <a-tag :class="{'tag-active':item.dictValue==paymentTypes}"  @click="postSerchData({'paymentType':item.dictValue})" v-for="(item,key) in options.paymentType" :key="key">{{item.dictLabel}}</a-tag>
    </div>
  </div>
  <div class="cont_body">
    <div v-for="(item,key) in optionsData" :key="key" class="list_cont" @click="goMore('/finance/product/page','金融产品',item.id)">
      <div class="list_img">
        <img :src="getImg(item.img)" alt="">
      </div>
      <div class="list_cont_body">
        <h4>{{item.productName}}：<dict-render :dict-obj="dictObjs['paymentType']"
          :text="item.paymentType"></dict-render> </h4>
        <P>产品介绍：{{item.details}}</P>
        <P>申请条件：{{item.loanConditions}}</P>
      </div>
      <div class="list_cont_pay">
        <p>贷款额度：<span>{{item.maxLoanLines}}</span>万元</p>
        <p>贷款利率：<span>{{item.rate}}</span>%</p>
        <p>担保方式：<span>
          <dict-render :dict-obj="dictObjs['guarantee']"
          :text="item.guarantyType"></dict-render></span></p>
      </div>
      <div class="list_botton">
        <a-button style="margin-top: 18px;" >立即申请</a-button>
      </div>
    </div>
  </div>
  <a-pagination style="clear:both;float:right" v-model:current="current" :total="10" show-less-items />
</template>
<script>
import { dictMixin } from "@/mixins";
import {financeProductWeb} from "@/api/finance";
import {common_controller} from "@/api/commonService";
import {file_service} from "@/api/adminService";
import DictRender from "@/components/other/DictRender";
export default {
  name: 'investor',
  components: { DictRender },
  mixins: [dictMixin],
  props: {
    title: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      guarantees:'',
      options:null,
      loanDeadlines:'',
      paymentTypes:'',
      dictNames: 'paymentType,guarantee',
      optionsData:null,
    }
  },
  mounted() {
      this.getDict();
      this.getSerchData();
  },
	methods: {
    postSerchData(val){
      if(val=='guarantee'){
          this.guarantees = ''
      }else if(val=='loanDeadline'){
        this.loanDeadlines = ''
      }else if(val=='paymentType'){
        this.paymentTypes = ''
      }else{
        if(val.guarantee){
          this.guarantees = val.guarantee
        }
        if(val.loanDeadline){
          this.loanDeadlines = val.loanDeadline
        }
        if(val.paymentType){
          this.paymentTypes = val.paymentType
        }
      }
      this.getSerchData()
      
    },
    getSerchData(){
      this.getAction({
            url: financeProductWeb.pageList,
            params: {
              pageNum: 1,
              pageSize: 10,
              guarantyType: this.guarantees,
              loanDeadline: this.loanDeadlines,
              paymentType: this.paymentTypes
            },  
        }).then(res => {
          this.optionsData = res.records
        })
    },
    getDict(){
        this.getAction({
            url:common_controller.getDictDataByGroupNumber,
            params: {
                groupNumbers: "guarantee,loanDeadline,paymentType"
            }
        }).then(res=>{
            this.options = res
        })
    },
    getImg(imgUrl) {
        return file_service.imagesWeb(imgUrl)
    },
		goMore(url,key,id) {
			this.$router.push({path: url, query: {type: key,queryData: id}})
		},
		backhome() {
      this.goMore('/finance/index')
      // location.reload()
		}
	}
}
</script>
<style scoped lang="less">
@import "../../../css/components.less";
.list_cont{
  color:#b3b2b2;
  width:100%;
  margin-bottom: 16px;
  display: flex;
  &:hover {
    :deep(.ant-btn){
      color:#fff;
      border:1px solid #1890ff;
      background: #1890ff;
    }
  }
  .list_img{
    width: 80px;
    height: 80px;
    overflow: hidden;
    border:1px solid #eeeeee;
    margin:20px 30px 20px 20px;
    display: flex;
    align-items: center;
    img{
      width: 100%;
    }
  }
  .list_cont_body{
    flex: 4;
    h4{
      margin-bottom: 20px;
    }
    p{
      word-break: break-all;
      overflow:hidden; 
      text-overflow:ellipsis; 
      display:-webkit-box;
      -webkit-box-orient:vertical;  
      -webkit-line-clamp:1;
    }
  }
  .list_cont_pay{
    flex: 3;
    padding-left: 40px;
    p{
      line-height: 35px;
      span{
        color:red
      }
    }
  }
  .list_botton{
    flex: 1;
  }
}

:deep(.ant-btn){
	border-radius: 0;
}
</style>